export var AccountStatus;
(function (AccountStatus) {
    AccountStatus[AccountStatus["Inactive"] = 0] = "Inactive";
    AccountStatus[AccountStatus["Active"] = 1] = "Active";
    AccountStatus[AccountStatus["Prospect"] = 2] = "Prospect";
})(AccountStatus || (AccountStatus = {}));
export function getAccountStatusList() {
    return [0, 1, 2].map((i) => ({ code: i, name: AccountStatus[i] }));
}
//# sourceMappingURL=account.status.js.map